import React, { SyntheticEvent } from 'react';
import { Language } from '@/entities';
import LanguageIcon from '~/glyphs/lang-20.svg';
import { LANGUAGE_OPTIONS } from './constants';
import {
  Container, IconContainer, Select,
} from './styles';

interface ILanguageSelectProps {
  value: Language;
  onChange: (value: Language) => void;
}

export const LanguageSelect = ({
  value,
  onChange,
}: ILanguageSelectProps) => {
  const handleChange = (event: SyntheticEvent<HTMLSelectElement>) => {
    onChange(event.currentTarget.value as Language);
  };

  return (
    <Container>
      <IconContainer>
        <LanguageIcon />
      </IconContainer>
      <Select
        id="language"
        name="language"
        value={value}
        onChange={handleChange}
      >
        {LANGUAGE_OPTIONS.map((item) => {
          return (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          );
        })}
      </Select>
    </Container>
  );
};
